(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMenuSite', taiMenuSite);

    function taiMenuSite() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            templateUrl: 'directive/taiMenuSite.html',
            scope: {
                data: '=',
                menuId: '@',
                showMode: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(menuService, $location, $http, apiUrl, commonService,$element) {
        var vm = this;
        // 1.8.2 父層傳遞參數 如果失效從 $element 取得
        if (vm.menuId == null || vm.menuId == undefined) {
            vm.menuId = $element.attr('menu-id');
        }
        if (vm.showMode == null || vm.showMode == undefined) {
            vm.showMode = $element.attr('show-mode');
        }

        vm.enumShowMode = {
            fullPath: '1', //......代表這段麵包屑是完整的，不會與其他東西串接
            partPath: '2', //......代表這段麵包屑只是其中一部分。
        };
        var tsunOutside = 4;
        var menuUrl = apiUrl.tsApi + 'menu/';
        vm.rootClick = rootClick;
        vm.childClick = childClick;
        vm.rootHove = rootHove;
        vm.rootClear = rootClear;

        init();

        function init() {
            vm.config = {
                showMode: vm.showMode || vm.enumShowMode.fullPath, //麵包屑的顯示模式設定
            };
            var param = {
                menuSerilNo: vm.menuId || getMenuQueryString(),
                siteCode: tsunOutside
            };
            commonService.setParams(param);
            //console.log('menu param:',param);
            $http.post(menuUrl + 'getMenuParent', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(data) {
                //console.log('menu data:',data.data);
                vm.parent = data.data;
            });
        }

        function rootClick(item) {
            if (!item) {
                return; }
            if (item.url) {
                menuService.redirectUrl(item);
            }
        }

        function rootHove(item) {
            vm.child = null;
            var param = {
                menuSerilNo: item.menuSerilNo,
                globalMenuSerilNo: vm.menuId || getMenuQueryString(),
                siteCode: tsunOutside
            };

            commonService.setParams(param);
            $http.post(menuUrl + 'getMenuChild', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(data) {
                vm.child = data.data;
            });
        }

        function rootClear() {
            vm.child = null;
        }

        function childClick(item) {
            menuService.redirectUrl(item);
        }

    }
})();
